<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div>
    <InputLabel
      :name="name"
      :label="label"
      :tooltip="tooltip"
      :tooltip-icon="tooltipIcon"
      :required="required"
      v-if="label"
    >
      <slot name="label"></slot>
    </InputLabel>
    <Textarea
      :id="name"
      v-model="value"
      :aria-describedby="`${name}-help`"
      :class="{ 'p-invalid': errorMessage }"
      v-bind="$attrs"
    >
    </Textarea>
    <InputError :name="name" :error-message="errorMessage" />
  </div>
</template>

<script setup>
import { useField } from 'vee-validate';
import { toRef } from 'vue';

import InputLabel from '@/components/forms/helpers/InputLabel.vue';
import InputError from '@/components/forms/helpers/InputError.vue';
import Textarea from 'primevue/textarea';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  tooltip: {
    type: String,
    default: null,
  },
  tooltipIcon: {
    type: String,
    default: 'pi-info-circle',
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const { value, errorMessage } = useField(toRef(props, 'name'));
</script>

<script>
export default {
  inheritAttrs: false,
};
</script>
